import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import {
  PUBLIC_COMPANIES,
  SPECIFIED_VOLATILITY,
} from 'pages/Valuations/approaches/backsolveApproach/OPMInputTable/constants';
import customValidations from 'pages/Valuations/approaches/backsolveApproach/OPMInputTable/customValidations';
import parser from 'pages/Valuations/approaches/backsolveApproach/OPMInputTable/parser';
import reverseParser from 'pages/Valuations/approaches/backsolveApproach/OPMInputTable/reverseParser';
import { extractGPCApproaches } from 'pages/Valuations/util/util';
import afterCellChanged from './afterCellChanged';
import conditions from './conditions';
import { CreateOPMInputDataParams } from './types';

const createOpmInputData = ({
  attrs,
  tableName,
  data,
  approaches,
  measurementDate,
  isDisabled,
}: CreateOPMInputDataParams) => {
  const name = tableName;
  const column = data;
  const getColumns = () => [{}, column];
  const columns = getColumns();
  const rowTemplate = {
    ignoreRowCopy: true,
  };
  const volatilitySourceOptions = [{ value: null, label: SPECIFIED_VOLATILITY }, ...extractGPCApproaches({ approaches })];
  const gpcApproaches = approaches.filter(({ approach_type }) => approach_type === PUBLIC_COMPANIES);
  return new SpreadsheetConfig({
    name,
    parser,
    reverseParser: reverseParser as unknown as SpreadsheetConfig['reverseParser'],
    afterCellChanged: afterCellChanged as unknown as SpreadsheetConfig['afterCellChanged'],
    conditions: conditions as unknown as SpreadsheetConfig['conditions'],
    rowConfig: [
      { ...rowTemplate },
      { ...rowTemplate },
      { ...rowTemplate },
      { ...rowTemplate },
      { ...rowTemplate },
      { ...rowTemplate },
    ] as unknown as SpreadsheetConfig['rowConfig'],
    tableData: { data, approaches, measurementDate, isDisabled, volatilitySourceOptions, gpcApproaches },
    customValidations: customValidations as unknown as SpreadsheetConfig['customValidations'],
    columns,
    showTitlesColumn: false,
    fieldAttributes: attrs,
    hasColTitle: false,
    getColumns,
    format: undefined,
    currencyFormatter: false,
    unitsFormatter: false,
    totalParser: undefined,
  });
};

export default createOpmInputData;
